import { createAxios } from "./createAxios";

export async function Authenticate(userName, password) {
    return await createAxios().post("/Authentication/Authenticate",
        {
            userName: userName,
            password: password,
            isPersistent: 1
        })
}